/** Default 6-char hex for signature API icon URLs (matches color_redes base). */
export const DEFAULT_SIGNATURE_ICON_COLOR = '068686';

export const SIGNATURE_API_BASE = 'https://api.linkcard.app/api/signature';

/**
 * Normalizes a hex color for signature API icon URLs.
 * The API expects a 6-char hex string without `#` or alpha channel.
 */
export function normalizeSignatureColor(hex, fallback = DEFAULT_SIGNATURE_ICON_COLOR) {
    if (!hex || typeof hex !== 'string') return fallback;
    const stripped = hex.replace(/^#/, '');
    const rgb = stripped.slice(0, 6);
    if (/^[0-9a-fA-F]{6}$/.test(rgb)) return rgb.toLowerCase();
    return fallback;
}

/**
 * Builds a signature icon URL for the Linkcard API.
 *
 * Color usage in templates:
 * - Contact icons (email, phone, calendar, etc.) → `color_btn_sec`
 * - Social network icons → `color_redes`
 * Both map to the same API path pattern; only the color source differs by design.
 */
export function getSignatureIconUrl(network, color, baseUrl = SIGNATURE_API_BASE, variant = 'icon') {
    const normalized = normalizeSignatureColor(color);
    return `${baseUrl}/${network}/${variant}/${normalized}.png`;
}
